/**
 * @source @open-social-protocol/osp-api-index-types result-wrapper.ts (osp-client 1.2.x)
 */

export class IndexError extends Error {
  readonly code: string;
  readonly data: unknown;

  constructor(data?: unknown) {
    const code = "INDEX_ERROR";
    const msg = data ? `${code}: ${JSON.stringify(data)}` : code;
    super(msg);
    this.name = "IndexError";
    this.data = data;
    this.code = code;
  }
}
